import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { s3bucketPublicURL, uploadsURL, activitiesKey } from 'config';

import StopItAnswers from './StopItAnswers/StopItAnswers';
import KeepGoingAnswers from './KeepGoingAnswers/KeepGoingAnswers';

const getNumAnimationSpeed = speed => {
  const animationSpeed = {
    slow: 3000,
    medium: 2000,
    fast: 1000
  };

  return animationSpeed[speed] || 2000;
};

const colors = [

  /*{ backgroundColor: '#f0d8ff', borderColor: '#d897ff', borderWidth: '2px' },
  { backgroundColor: '#ffced0', borderColor: '#FF8B90', borderWidth: '2px' },
  { backgroundColor: '#ffe7c1', borderColor: '#FFC972', borderWidth: '2px' },
  { backgroundColor: '#ccf2ff', borderColor: '#47D2FF', borderWidth: '2px' },
  { backgroundColor: '#e8fff3', borderColor: '#B7FAD8', borderWidth: '2px' }*/

  { backgroundColor: '#ffffff', borderColor: '#d897ff', borderWidth: '2px' },
  { backgroundColor: '#ffffff', borderColor: '#FF8B90', borderWidth: '2px' },
  { backgroundColor: '#ffffff', borderColor: '#FFC972', borderWidth: '2px' },
  { backgroundColor: '#ffffff', borderColor: '#47D2FF', borderWidth: '2px' },
  { backgroundColor: '#ffffff', borderColor: '#B7FAD8', borderWidth: '2px' }
];

const AnswersBlock = ({
  activity,
  question,
  resolved,
  multiplayer,
  animation,
  textStyle,
  answerClickHandler,
  versionType,
  forceCorrectAnswerVisible = false,
  mobileInteraction = false,
  mobileSelectedAnswerId = null,
  isAndroidMobile = false,
  workAreaStyle,
}) => {
  const { options, gameData: defaultGameData } = activity.data;
  const { contentFolder } = activity.activity;
  // Use the same authored content version as MovingAnswers. The previous code
  // always used English/base rendering flags while questions and media could
  // come from immersion_* (incorrect animation type or empty answer cards).
  const localizedGameData = versionType
    ? activity.data.languageVersionData?.[versionType]
    : null;
  const gameData = localizedGameData || defaultGameData || {};
  const { withAudio, useImages, longAnswers } = gameData;

  const isKeepGoingAnimations = !longAnswers && !withAudio;

  const animationSpeed = useMemo(
    () => getNumAnimationSpeed(options.animationSpeed),
    [options]
  );

  if (!question) return null;

  const hasLocalizedGameData = !!localizedGameData;

  const contentPath = hasLocalizedGameData
    ? `${uploadsURL}/${activitiesKey}/${activity.activity._id}/languageVersionData/${versionType}/`
    : `${s3bucketPublicURL}/${contentFolder}/gamedata/`;

  console.log('[MovingAnswers][AnswersBlock][assetResolve]', {
    versionType,
    hasLocalizedGameData,
    contentPath,
    answerCount: question.answers?.length || 0,
    useImages: !!useImages,
    withAudio: !!withAudio,
    longAnswers: !!longAnswers,
    displayMode: isKeepGoingAnimations ? 'keep-going' : 'stop-it',
  });
  return isKeepGoingAnimations ? (
    <KeepGoingAnswers
      animation={animation}
      useImages={useImages}
      question={question}
      isResolved={resolved}
      isMultiplayer={multiplayer}
      animationSpeed={animationSpeed}
      contentPath={contentPath}
      colors={colors}
      textStyle={textStyle}
      coloredAnswerBoxes={options.coloredAnswerBoxes}
      visibleAfterResolvedTime={options.delayBeforeNext}
      forceCorrectAnswerVisible={forceCorrectAnswerVisible}
      mobileInteraction={mobileInteraction}
      mobileSelectedAnswerId={mobileSelectedAnswerId}
      isAndroidMobile={isAndroidMobile}
      workAreaStyle={workAreaStyle}
      clickHandler={answerClickHandler}
    />
  ) : (
    <StopItAnswers
      animation={animation}
      useImages={useImages}
      withAudio={withAudio}
      longAnswers={longAnswers}
      question={question}
      isResolved={resolved}
      isMultiplayer={multiplayer}
      animationSpeed={animationSpeed}
      contentPath={contentPath}
      colors={colors}
      textStyle={textStyle}
      coloredAnswerBoxes={options.coloredAnswerBoxes}
      visibleAfterResolvedTime={options.delayBeforeNext}
      forceCorrectAnswerVisible={forceCorrectAnswerVisible}
      mobileInteraction={mobileInteraction}
      mobileSelectedAnswerId={mobileSelectedAnswerId}
      isAndroidMobile={isAndroidMobile}
      workAreaStyle={workAreaStyle}
      clickHandler={answerClickHandler}
    />
  );
};

AnswersBlock.propTypes = {
  activity: PropTypes.object.isRequired,
  question: PropTypes.object,
  resolved: PropTypes.bool,
  multiplayer: PropTypes.bool,
  textStyle: PropTypes.object,
  answerClickHandler: PropTypes.func.isRequired,
  forceCorrectAnswerVisible: PropTypes.bool,
  mobileInteraction: PropTypes.bool,
  mobileSelectedAnswerId: PropTypes.string,
  isAndroidMobile: PropTypes.bool,
  workAreaStyle: PropTypes.object,
};

export default AnswersBlock;